module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ebc5ad4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperProfile/FormComponents/IntegerInput.vue
// module id = 1095
// module chunks = 2